import Utils from "@teamprevent/common/utils";

import axios from "axios";
import * as moment from "moment";

import * as models from "./models";

class ActionableTasksApi {

    private readonly apiUrl = "/api/actionabletask";

    public async getAll(): Promise<models.ActionableTasksListModel[]> {
        const response = await axios.get(`${this.apiUrl}${Utils.getOnlyParameters()}`);
        const data = response.data as models.ActionableTasksListModel[];
        return data.map(this.parseListModel);
    }

    public async get(caseId: string, taskId: string): Promise<models.ActionableTaskDetailModel> {
        const response = await axios.get(`${this.apiUrl}/${caseId}/${taskId}${Utils.getOnlyParameters()}`);
        const result = Utils.CheckResponse(response.data);
        return this.parseModel(result as models.ActionableTaskDetailModel);
    }

    public async actionInsufficientInformationTask(model: models.FollowUpInsufficientInformationModel): Promise<boolean> {
        const response = await axios.post(this.apiUrl, model);
        const result = Utils.CheckResponse(response.data);
        return result as boolean;
    }

    public parseModel(model: models.ActionableTaskDetailModel): models.ActionableTaskDetailModel {
        return {
            ...model,
            ohCase: {
                ...model.ohCase,
                created: moment(model.ohCase.created),
                referralSubmittedDate: model.ohCase.referralSubmittedDate && moment(model.ohCase.referralSubmittedDate)
            }
        };
    }

    public parseListModel(model: models.ActionableTasksListModel): models.ActionableTasksListModel {
        return {
            ...model,
            created: moment(model.created)
        };
    }
}

export default new ActionableTasksApi();
